import { useEffect } from "react";
import { Link } from 'react-router-dom';

import { getEndpoint } from "../helper";

import './welcome.scss';

export default function Welcome(props) {
    useEffect(() => {
        $('.js__slick').slick({
            rtl: true,
            arrows: false,
            dots: true
        });
    }, []);

    return (
        <>
            <div className="image-slider js__slick" data-slick="">
                <div>
                    <img src={getEndpoint("/pwa/img/welcome_1.jpg")} alt="مقایسه قیمت ها" className='mx-a h-100vh' />
                </div>
                <div>
                    <img src={getEndpoint("/pwa/img/welcome_2.jpg")} alt="مرجوع کالا" className='mx-a h-100vh' />
                </div>
                <div>
                    <img src={getEndpoint("/pwa/img/welcome_3.jpg")} alt="جستجو" className='mx-a h-100vh' />
                </div>
            </div>
            <div className="entry-button-wrap px-5 p-a w-100">
                <Link to="/signin" role='button' className='_bc-g c-w box-sh d-f ai-c jc-c w-100 br-4 py-3 us-n'>ورود به برنامه</Link>
            </div>
        </>
    );
}